import type { SimpleSearchConfig } from '@/shared/ui/search/SimpleSearch/types/search.types';
import type { SearchConfig } from '@/shared/ui/search/AdvancedSearch/types/query.types';
import type { SortConfig } from '@/shared/ui/search/AdvancedSearch/types/query.types';

/**
 * SimpleSearch 설정
 */
export const orderSimpleSearchConfig: SimpleSearchConfig = {
  fields: [
    { name: 'misoOrderId', label: '주문번호' },
    { name: 'ordererPhone', label: '주문자 전화번호' },
    { name: 'departureLocation', label: '출발지' },
    { name: 'arrivalLocation', label: '도착지' },
  ],
  placeholder: '주문번호, 전화번호, 주소로 검색',
  enableFieldSelect: true,
};

/**
 * AdvancedSearch 설정
 */
export const orderAdvancedSearchConfig: SearchConfig = {
  fields: [
    {
      name: 'misoOrderId',
      label: '주문번호',
      type: 'text',
      operators: ['EQUALS', 'CONTAINS'],
    },
    {
      name: 'ordererPhone',
      label: '주문자 전화번호',
      type: 'text',
      operators: ['EQUALS', 'CONTAINS'],
    },
    {
      name: 'ordererMisoCustomerId',
      label: '미소 고객 ID',
      type: 'text',
      operators: ['EQUALS', 'CONTAINS'],
    },
    {
      name: 'statuses',
      label: '상태',
      type: 'multiselect',
      operators: ['IN'],
      options: [
        { value: 'Received', label: '접수됨' },
        { value: 'Scheduling', label: '일정 조율 중' },
        { value: 'VisitAppointed', label: '방문 예약됨' },
        { value: 'VisitCompleted', label: '방문 완료됨' },
        { value: 'Requote', label: '재견적' },
        { value: 'Unqualified', label: '중복됨' },
        { value: 'ClosedLost', label: '취소됨' },
      ],
    },
    {
      name: 'moveDate',
      label: '이사일',
      type: 'date',
      operators: ['RANGE_GTE', 'RANGE_LTE'],
    },
    {
      name: 'orderedAt',
      label: '주문일시',
      type: 'datetime',
      operators: ['RANGE_GTE', 'RANGE_LTE'],
    },
    {
      name: 'departureLocation',
      label: '출발지',
      type: 'text',
      operators: ['CONTAINS'],
    },
    {
      name: 'arrivalLocation',
      label: '도착지',
      type: 'text',
      operators: ['CONTAINS'],
    },
  ],
  sortFields: [
    { name: 'orderedAt', label: '주문일시' },
    { name: 'moveDate', label: '이사일' },
    { name: 'id', label: 'ID' },
  ],
  defaultSort: {
    field: 'orderedAt',
    direction: 'DESC',
  },
  defaultPageSize: 20,
};

/**
 * 기본 정렬 설정
 */
export const defaultOrderSort: SortConfig = {
  field: 'orderedAt',
  direction: 'DESC',
};
